<div class="transport-option-constraints-editor">

  <sc-master-detail [selection]="[selectedConstraint]" [data]="context.constraints"
    (selectionChanged)="onSelectionChanged($event);" (addEntry)="onAddEntry($event);"
    (deleteEntry)="onDeleteEntry($event);" [level]="2">


    <div class="constraint-box" [formGroup]="detailsFormGroup">
      <div class="constraint-box-layout" *ngIf="selectedConstraint">

        <sc-string-field [required]="true" labelDictionaryKey="tmc-yard.entity.transport-option-constraint.name"
          formControlName="name"></sc-string-field>

        <sc-select-field formControlName="type" [data]="constraintTypeOptions"
          labelDictionaryKey="tmc-yard.entity.transport-option-constraint.type"></sc-select-field>

        <!-- <mat-form-field>
          <mat-select formControlName="type" name="type" required="true"
            placeholder="{{'name' | translate: ['tmc-yard.entity.transport-option-constraint.type', translationService.language]}}">
            <mat-option [value]="type" *ngFor="let type of constraintTypes">
              {{' ' | translate: ['tmc-yard.entity.transport-option-constraint.type.'+type,
              translationService.language]}}
            </mat-option>
          </mat-select>
        </mat-form-field> -->

        <sc-number-field [required]="true" labelDictionaryKey="tmc-yard.entity.transport-option-constraint.count"
          formControlName="count"></sc-number-field>

        <app-constraint-option-assignment-editor [setOptions]="context.options" [setAssignedOptions]="assignedOptions"
          (assignedOptionsChanged)="onAssignedOptionsChanged($event)">
        </app-constraint-option-assignment-editor>

      </div>
    </div>

  </sc-master-detail>
</div>
